<template>
  <div
    ref="chartDomRef"
    class="chart distance-polyline"
  ></div>
</template>

<script setup>
import unitHelper from '@client/helper/unit';
import { getCurrentInstance, ref, watch } from 'vue';
import useDrawChart from '../useDrawChart';

import { DistancePolylineChart } from './chart';
import useXAxisConfig from '../useXAxisConfig';
import { usePakHo } from '@client/pages/activity-detail/hooks/usePakHo';
import useDistancePolylineChart from '../useDistancePolylineChart';
import { xAxisKeyMap } from '@client/store/activityDetailStore';
import { useActiveAttributes } from '../useActiveAttributes';

const vm = getCurrentInstance();
const t = vm.proxy.$root.$t;

const chartDataType = 'portion';
const xAxisKey = xAxisKeyMap['distance-polyline'];

const chartRef = ref(null);
const chartDomRef = ref(null);

// var a = {
//   watch: {
//     showOverview(val, oldVal) {
//       this.tryToDrawChart();
//     },
//   }
// };

const { xAxisConfig } = useXAxisConfig({ isPortion: true });
const { chartData, pauseList, tryToDrawChart } = useDrawChart({
  isOverview: false,
  drawChart
});
const { chartAttr, activeAttributes } = useActiveAttributes({ isOverview: true });
watch(activeAttributes, tryToDrawChart);
const { chartNames, xTickInfo, attributes } = useDistancePolylineChart({ activeAttributes, chartAttr });

const { crossHairMove } = usePakHo();
function crossHairCallback(e, data) {
  // 暂停区间补充的空数据不传到外部
  if (data.isPauseZoneNullData) {
    return;
  }
  crossHairMove(unitHelper.clone(data));
}

// 绘制图表
function drawChart() {
  chartRef.value?.remove();

  let left = 0;
  let right = 0;
  let chartCount = chartNames.value.length;
  if (chartNames.value.includes('Air_Power')) {
    chartCount--;
  }

  switch (chartCount) {
    case 1:
      left = 40;
      right = 30;
      break;
    case 2:
      left = 40;
      right = 40;
      break;
    case 3:
      left = 85;
      right = 40;
      break;
    case 4:
      left = 85;
      right = 85;
      break;
  }

  if (chartCount > 4) {
    left = 85;
    right = 85;
  }

  chartRef.value = new DistancePolylineChart({
    el: chartDomRef.value,
    theme: 'theme-dark',
    recommandLabel: t('S4493'),
    margin: {
      top: 20,
      bottom: 22,
      left,
      right
    },
    // x轴使用的属性字段名
    xAxisKey,
    // x轴刻度显示的文本信息转换方法，不传则直接使用属性值
    xTickInfo: xTickInfo,
    showYLine: false,
    crossHairCallback: crossHairCallback
  });

  const dataList = chartData.value;
  const startX = xAxisConfig.value.startX;
  const endX = xAxisConfig.value.endX;
  const xTicks = xAxisConfig.value.xTicks;

  // 注入数据
  chartRef.value.setData(dataList);
  // 创建x轴比例尺
  chartRef.value.createXAxis([startX, endX]);
  // 绘制x轴
  chartRef.value.drawXScale(xTicks);
  // 设置显示的属性
  chartRef.value.setShowingAttributes(attributes.value);
  // 生成暂停虚线
  chartRef.value.drawPauseLine(pauseList.value);
}
</script>

<style lang="scss" scoped>
.chart {
  width: 100%;
  height: 100%;
}
</style>
